import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { PopoverModule, RatingModule, TooltipModule } from 'ngx-bootstrap';
import { MaskPipe, NgxMaskModule } from 'ngx-mask';
import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { HttpClientModule } from '@angular/common/http';
import { AppTranslationModule } from '../translations/app-translations.module';
import { AppCommonModuleConstants } from './app-common.module.constants';
import { BestSellerProductsComponent } from './components/bestseller.component';
import { PricePopoverComponent } from './components/price-popover.component';
import { QuickviewComponent } from './components/quickview.component';
import { AccordianDirective } from './directives/accordian.directive';
import { AppModalDirective } from './directives/app-modal.directive';
import { CardNavigationDirective } from './directives/card-navigation.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { FooterLearnMoreDirective } from './directives/footer-learn-more.directive';
import { ImgSrcDirective } from './directives/img-src.directive';
import { NoImageDirective } from './directives/no-image.directive';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { ScrollSpyDirective } from './directives/scroll-spy.directive';
import { SlimScrollDirective } from './directives/slimscroll.directive';
import { CCPipe } from './pipes/cc-value-format.pipe';
import { ChildImageFilterPipe } from './pipes/child-image-filter.pipe';
import { CurrencyPipe } from './pipes/currency-format.pipe';
import { DistributorIdFormat } from './pipes/distributor-id-format.pipe';
import { AutofocusDirective } from './directives/auto-focus.directive';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { FieldFilterPipe } from './pipes/field-filter.pipe';
import { HighlightSearch } from './pipes/highlight.pipe';
import { ImageTypeFilterPipe } from './pipes/image-type-filter.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SingleImageFilterPipe } from './pipes/single-image.filter.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { TranslateKey } from './pipes/translate-key.pipe';
import { UniqueByPipe } from './pipes/unique-by.pipe';
import { ProductService } from './services/product.service';
import { TabOrderDirective } from './directives/tab-order.directive';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto',
  keyboard: true,
};


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SwiperModule,
    RouterModule,
    AppTranslationModule,
    RatingModule,
    RouterModule,
    Ng2DeviceDetectorModule.forRoot(),
    PopoverModule.forRoot(),
    TooltipModule.forRoot(),
    NgxMaskModule.forRoot()
  ],
  declarations: [
    AppCommonModuleConstants.MODULE_COMPONENTS,
    ImageTypeFilterPipe,
    SingleImageFilterPipe,
    HighlightSearch,
    UniqueByPipe,
    CurrencyPipe,
    //DateFormatPipe,
    ChildImageFilterPipe,
    TranslateKey, FieldFilterPipe,
    CCPipe, SafeUrlPipe, TranslateKey, SortPipe,
    BestSellerProductsComponent,
    QuickviewComponent,
    SlimScrollDirective,
    OnlyNumberDirective,
    EllipsisPipe,
    ImgSrcDirective, NoImageDirective, ClickOutsideDirective,
    AccordianDirective,
    PricePopoverComponent,
    CardNavigationDirective,
    FooterLearnMoreDirective,
    AppModalDirective,
    ScrollSpyDirective,
    DistributorIdFormat,
    AutofocusDirective,
    TabOrderDirective
  ],
  providers: [{
    provide: SWIPER_CONFIG,
    useValue: DEFAULT_SWIPER_CONFIG
  }, ChildImageFilterPipe, CurrencyPipe, TranslateKey, ProductService, MaskPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    SwiperModule,
    AppTranslationModule,
    RouterModule,
    AppCommonModuleConstants.MODULE_COMPONENTS,
    HighlightSearch,
    ImageTypeFilterPipe,
    SingleImageFilterPipe,
    UniqueByPipe,
    CurrencyPipe,
    //DateFormatPipe,
    SafeUrlPipe,
    CCPipe, TranslateKey, SortPipe,
    FieldFilterPipe,
    BestSellerProductsComponent,
    QuickviewComponent,
    SlimScrollDirective,
    EllipsisPipe,
    ChildImageFilterPipe,
    ImgSrcDirective, Ng2DeviceDetectorModule, NoImageDirective,
    RatingModule, ClickOutsideDirective, TooltipModule, PopoverModule,
    AccordianDirective,
    PricePopoverComponent,
    CardNavigationDirective,
    FooterLearnMoreDirective,
    AppModalDirective,
    ScrollSpyDirective,
    NgxMaskModule,
    DistributorIdFormat,
    AutofocusDirective,
    TabOrderDirective
  ],
  entryComponents: [QuickviewComponent]
})
export class AppCommonModule { }
